import React, { useCallback, useEffect, useState } from "react";
import { Button, Col, Form, Row, Table } from "react-bootstrap";
import up_down_arrow from "../../../../../Assets/svg/up_down_arrow.svg";

// img
import user from "../../../../../Assets/images/user.png";
import action_icon_1 from "../../../../../Assets/svg/tableData/action-icon-1.svg";
import action_icon_2 from "../../../../../Assets/svg/tableData/action-icon-2.svg";
import { useSelector } from "react-redux";
import { del, post, updateToken } from "../../../../../helpers/api_helper";
import moment from "moment";
import toast from "react-hot-toast";
import DeleteConfirmationModal from "../../../../../components/DeleteConfirmation";
import Pagination from "../../../../../components/Pagination";
import NewSubAdmin from "../Modal/NewSubAdmin";
import useCheckPermission from "../../../../../hooks/useCheckPermission";
import Loader from "../../../../../components/shared/Loader";

const SubAdmin = () => {

  const token = useSelector((state) => state.login.token);
  const [data, setData] = useState([]);
  const [showConfirm, setShowConfirm] = useState(false);
  const [currentItem, setCurrentItem] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [totalPages, setTotalPages] = useState(0);
  const [showEditModal, setShowEditModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const hasUpdatePermission = useCheckPermission("subAdmin", "UPDATE");
  const hasDeletePermission = useCheckPermission("subAdmin", "DELETE");

  const fetchSubAdmins = useCallback(async () => {
    try {
      setIsLoading(true);
      const response = await post("/sub-admin/list", { skip: (currentPage - 1) * 10, limit: itemsPerPage });
      if (response?.success) {
        setData(response?.data?.list);
        setTotalPages(Math.ceil(response?.data?.count / 10))
      }
      setIsLoading(false);
    } catch (error) {
      console.log("An error occurred while fetching sub admin", error);
      setIsLoading(false);
    }
  }, [currentPage]);

  const handleDelete = async () => {
    try {
      const response = await del(`/sub-admin/remove/${currentItem?._id}`);
      if (response.success) {
        toast.success("Role deleted successfully");
        fetchSubAdmins();
      } else {
        toast.error("Failed to delete role");
      }
    } catch (err) {
      toast.error("An error occurred while deleting role");
    } finally {
      setShowConfirm(false);
    }
  };

  const confirmDelete = (data) => {
    setCurrentItem(data);
    setShowConfirm(true);
  };

  const handlePageChange = (newPage) => {
    if (newPage > 0 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  useEffect(() => {
    fetchSubAdmins();
  }, [currentPage]);

  useEffect(() => {
    updateToken(token); // Ensure token is updated once
  }, [token]);

  return (
    <>
      <DeleteConfirmationModal
        show={showConfirm}
        onHide={() => setShowConfirm(false)}
        onConfirm={handleDelete}
      />
      <NewSubAdmin
        show={showEditModal}
        onHide={setShowEditModal}
        clientDetails={currentItem}
        refetch={fetchSubAdmins}
      />
      {isLoading ? (
        <Loader />
      ):(
        <>
          <Table responsive>
            <thead>
              <tr>
                <th className="fw-normal border-0">
                  Name
                  {/* <Button className="border-0 p-0" variant="transparent">
                    Name
                    <span className="icn ms-2">
                      <img src={up_down_arrow} alt="" />
                    </span>
                  </Button> */}
                </th>
                <th className="fw-normal border-0">Status</th>
                <th className="fw-normal border-0">Email</th>
                <th className="fw-normal border-0">Role</th>
                <th className="fw-normal border-0">
                  Created at
                  {/* <Button className="border-0 p-0" variant="transparent">
                    Created at{" "}
                    <span className="icn ms-2">
                      <img src={up_down_arrow} alt="" />
                    </span>
                  </Button> */}
                </th>
                <th className="fw-normal border-0">Action</th>
              </tr>
            </thead>
            <tbody>
              {data?.length > 0 ?
                data.map((data, key) => (
                  <tr key={key}>
                    <td>{data?.name ? data?.name : "-"}</td>
                    <td>{data.status}</td>
                    <td>{data.email}</td>
                    <td>{data.roleDetails?.name || "--"}</td>
                    <td>
                      {data?.createdAt
                        ? moment(data.createdAt).format("DD-MM-YYYY hh:mm A")
                        : "-"}
                    </td>
                    <td>
                      <td>
                        <div className="d-flex align-items-center gap-10">
                          {hasUpdatePermission && <Button
                            // onClick={handleAddUpdate}
                            className="border-0 p-0"
                            variant="transparent"
                            onClick={() => {
                              setCurrentItem(data);
                              setShowEditModal(true);
                            }}

                          >
                            <img src={action_icon_1} alt="" />
                          </Button>}
                          {hasDeletePermission && <Button
                            className="border-0 p-0"
                            variant="transparent"
                            onClick={() => confirmDelete(data)}
                          >
                            <img src={action_icon_2} alt="" />
                          </Button>}
                        </div>
                      </td>
                    </td>
                  </tr>
                )):(
                  <tr>
                    <td colSpan={6} className="text-center">No data found</td>
                  </tr>
                )}
            </tbody>
          </Table>
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
          />
        </>
      )}
    </>
  );
};

export default SubAdmin;
